<template>
  <v-navigation-drawer
    app
    clipped
    :value="doesShowDrawer"
    :expand-on-hover="isMobileViewport || !doesShowExpand"
    stateless
    width="170"
    :style="'background-color:#fff;'"
  >
    <v-list>
      <v-list-item
        v-for="(item, index) in items"
        :key="index"
        @click="onClickMenuItem(item)"
        :class="activePath === item.to ? 'active_sidebar' : 'non_active_sidebar'"
      >
        <v-icon>{{ item.icon }}</v-icon>
        <v-list-item-title>{{ item.title }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>
<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';
import Store from '@/store';
import { updateActivePath } from '@/libs/store/common';
import { undoWarn } from '@/libs/store/warn';
import { undoError } from '@/libs/store/error';
import { undoSuccess } from '@/libs/store/success';
import { getProductLabel } from '@/libs/llc/database/property';

interface MenuItem {
  title: string;
  icon: string;
  to: string;
}

@Component({})
export default class SideBar extends Vue {
  get items(): MenuItem[] {
    return [
      { title: 'ホーム', icon: 'mdi-home', to: '/dashboard/home' },
      { title: '予約管理', icon: 'mdi-calendar', to: '/dashboard/assignment/management' },
      { title: 'カメラ', icon: 'mdi-camera', to: '/dashboard/camera' },
      { title: 'デバイス操作', icon: 'mdi-lock-open', to: '/dashboard/lock/control' },
      { title: 'デバイス履歴', icon: 'mdi-history', to: '/dashboard/lock/history' },
      { title: '売上管理', icon: 'mdi-chart-areaspline', to: '/dashboard/analyzation' },
      { title: '顧客管理', icon: 'mdi-account', to: '/dashboard/customer/management' },
      ...(this.resourceAuthority || this.localPaymentAuthority
        ? [{ title: 'リソース管理', icon: 'mdi-semantic-web', to: '/dashboard/resource/management' }]
        : []),
      { title: `${this.productLabel}設定`, icon: 'mdi-google-classroom', to: '/dashboard/space/setting' },
    ];
  }

  get doesShowDrawer() {
    return Store.getters.common.doesShowDrawer;
  }

  get doesShowExpand() {
    return Store.getters.common.doesShowExpand;
  }

  get activePath() {
    return Store.getters.common.activePath;
  }

  get resourceAuthority(): boolean {
    return Store.getters.resourceAuthority;
  }

  get localPaymentAuthority(): boolean {
    return Store.getters.localPaymentAuthority;
  }

  get property() {
    return Store.getters.selectedProperty;
  }

  get isMobileViewport() {
    return ['xs', 'sm'].includes(this.$vuetify.breakpoint.name);
  }

  get productLabel() {
    return getProductLabel(this.property);
  }

  private onClickMenuItem(item: MenuItem) {
    const path = item.to;
    undoError();
    undoWarn();
    undoSuccess();
    updateActivePath(path);
    this.$router.push(path).catch((_e) => {});
  }
}
</script>

<style lang="scss">
.active_sidebar {
  border-left: thick solid #eaaa54;
  background-color: #faf0e6;
}
</style>
